module.exports = __webpack_public_path__ + "img/_weapon_spell_04.d607a416.png";